import { types } from 'mobx-state-tree';

import moment from 'moment-timezone';

import DateTime from '@utils/mst/types/DateTime';
import Organization from './Organization';

const BenefitVendor = types
  .model('BenefitVendor', {
    id: types.identifierNumber,
    name: types.string,
    logoUrl: types.maybeNull(types.string),
    description: types.maybeNull(types.string),
    eligibilityInfo: types.maybeNull(types.string),
    hoursOfOperation: types.maybeNull(types.string),
    createdAt: DateTime,
    updatedAt: types.maybeNull(DateTime),
    deletedAt: types.maybeNull(DateTime),
    organizations: types.maybeNull(types.array(types.reference(Organization))),
    criteria: types.maybeNull(types.union(types.string, types.frozen())),
    activeFrom: types.maybeNull(DateTime),
    activeTo: types.maybeNull(DateTime),
  })
  .views((self) => ({
    get createdAtMoment(): string {
      return moment(self.createdAt).format('DD MMMM YYYY hh:mm A');
    },
    get activeFromMoment(): string {
      return self.activeFrom ? moment(self.activeFrom).format('YYYY-MM-DDTHH:mm') : '';
    },
    get activeToMoment(): string {
      return self.activeTo ? moment(self.activeTo).format('YYYY-MM-DDTHH:mm') : '';
    },
  }));

export default BenefitVendor;
